import { render, staticRenderFns } from "./request-create.vue?vue&type=template&id=0738b242&scoped=true"
import script from "./request-create.vue?vue&type=script&lang=js"
export * from "./request-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0738b242",
  null
  
)

export default component.exports